module.exports = __webpack_public_path__ + "img/1010_sp.5eee1d1f.gif";